import React from "react";
import { Stack, Breadcrumb, Pivot, PivotItem } from "office-ui-fabric-react";
import { useHistory, useParams } from "react-router-dom";
import { IDataCenter } from "../../../vm";
import { getADataCenter } from "../../../services/datacenter/DatacenterService";
import { ToastContext } from "../../common/ToastProvider";
import { Loading } from "../../../services/Loading";
import { childrenGap8 } from "../../common/Constants";
import TempAndRhMain from "./TempAndRhMain";
import AmbientTempAndRhMain from "./AmbientTermpAndRhMain";

export interface TempAndRhTabMainProps {}

const TempAndRhTabMain: React.FC<TempAndRhTabMainProps> = () => {
  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    datacenter: {
      name: "",
    },
    selectedKey: "",
  } as {
    selectedKey: string;
    isLoading: boolean;
    datacenter: IDataCenter;
  });

  React.useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      setState({
        ...state,
        selectedKey: hash,
      });
    }
  }, [window.location.pathname]);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getADatacenter();
    };
    asyncFunc();
  }, []);

  const getADatacenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(params.dataCenterId);
    if (result && result.success) {
      setState({
        ...state,
        datacenter: result.data,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting datacenter details",
        "error"
      );
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + "#" + value.props.itemKey);
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap8}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.datacenter.name ? state.datacenter.name : "Datacenter",
                key: "datacenter",
              },
              {
                text: "Infrastructures (Automation)",
                key: "infrastructure-automation",
                onClick: () => {
                  history.push(`/datacenters/${params.dataCenterId}#infrastructure-automation`);
                },
              },
              {
                text: "Temperature and Humidity",
                key: "temp-rh",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Pivot
            onLinkClick={handleCallToRouter}
            getTabId={_getTabId}
            selectedKey={state.selectedKey}
          >
            <PivotItem
              itemKey="temp-rh"
              headerText="Temp & RH"
            >
              <TempAndRhMain datacenterId={params.dataCenterId} />
            </PivotItem>
            <PivotItem
              itemKey="ambient-temp-rh"
              headerText="Ambient Temp & RH"
            >
              <AmbientTempAndRhMain datacenterId={params.dataCenterId} />
            </PivotItem>
          </Pivot>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default TempAndRhTabMain;
